import Flex from '@Components/Bases/Flex';
import { CloudDownloadOutlined } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';

interface IScoreDetailsProps {
  score?: string;
  updateDate?: string;
  passStatus?: boolean;
  onDownload?: () => void;
}

const ScoreDetails = ({
  score,
  updateDate,
  passStatus,
  onDownload,
}: IScoreDetailsProps) => {
  return (
    <Flex flexDirection="column" alignItems="center" pb={2}>
      <Typography fontWeight="bold" variant="h2">
        {score}
      </Typography>
      <Typography>ข้อมูลล่าสุดเมื่อ {updateDate}</Typography>
      {onDownload && (
        <Button
          endIcon={<CloudDownloadOutlined />}
          disabled={passStatus}
          onClick={onDownload}
          variant="text"
          color="info"
        >
          ดาวน์โหลดเอกสาร
        </Button>
      )}
    </Flex>
  );
};

export default ScoreDetails;
